<base-index-page 
    [config]="baseIndexPageConfig"
    [service]="projectsService"
    [idKey]="'testlistId'"
    [subSectionSettings]="'deleteSettingsTestlist'"
></base-index-page>